// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QoYu","label":"styles_label__2hb3I"};